import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import DocumentTrailTable from './DocumentTrailTable';

type DocumentTrailModalProps = {
  isOpen: boolean;
  onClose: () => void;
  documentId?: string;
  navigationExamId?: string;
};

const DocumentTrailModal: React.FC<DocumentTrailModalProps> = ({ isOpen, onClose, documentId, navigationExamId }) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} style={{ maxWidth: '900px', width: '90%' }}>
      <div className="modal-header">
        <button
          aria-hidden={true}
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={onClose}
        >
          <i className="nc-icon nc-simple-remove" />
        </button>
        <h5 className="card-title">Document Trail</h5>
      </div>
      <ModalBody>
        {(documentId || navigationExamId) && (
          <DocumentTrailTable hideTitle documentId={documentId} navigationExamId={navigationExamId} />
        )}
      </ModalBody>
    </Modal>
  );
};

export default DocumentTrailModal;


